export * from './deleted-list.component';

